var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsotipoEg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.2 66.6",
    style: {
      enableBackground: "new 0 0 73.2 66.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EthicsGlobal_Espa\\xF1ol_Color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#159CD7",
    d: "M30.9,55.9L10.6,25.5l20.3,17.6l24.5-25C49.8,10.4,40.8,5.4,30.6,5.4C13.7,5.4,0,19.1,0,36 s13.7,30.6,30.6,30.6S61.2,52.9,61.2,36c0-5.4-1.4-10.5-3.9-14.9L30.9,55.9z M30.9,18c3.9,0,7,3.2,7,7.1s-3.2,7.1-7,7.1 c-3.9,0-7-3.2-7-7.1C23.8,21.2,27,18,30.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#159CD7",
    d: "M73.2,0L55.4,18.1c0.7,0.9,1.3,1.9,1.9,2.9L73.2,0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipoEg);
export default __webpack_public_path__ + "static/media/Isotipo_EG.36de05110710c23a2399c31f05e3269e.svg";
export { ForwardRef as ReactComponent };